import { getContent } from '@plone/volto/actions';

export const getCustomBlockAsyncData = ({ dispatch, id, data }) => {
  return [dispatch(getContent(data.target[0]['@id'], null, id))];
};
